import AdminEventForm from "./AdminEventForm";

const EventCreate = () => {
  return <AdminEventForm />;
};

export default EventCreate;
